import LeftPanel from './LeftPanel.container'
export default LeftPanel
